import { render, staticRenderFns } from "./Preview_deviz.vue?vue&type=template&id=62b311fb&scoped=true"
import script from "./Preview_deviz.vue?vue&type=script&lang=js"
export * from "./Preview_deviz.vue?vue&type=script&lang=js"
import style0 from "./Preview_deviz.vue?vue&type=style&index=0&id=62b311fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b311fb",
  null
  
)

export default component.exports